import Vue from "vue";
import Router from "vue-router";
import AuthRequired from "./utils/AuthRequired";
import { defaultPath } from "@/constants/config";
// Components
import MainNavbar from "./layout/TopNav";
// Router

import routerAuthen from "./pages/Authen/router";

Vue.use(Router);
const layout = {
  header: MainNavbar,
  // totop: Scrolltotop,
  // footer: MainFooter,
  // footernav: FooterNav,
  // contact: Messenger,
};
const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "active",
  mode: "history",
  routes: [
    {
      path: "/",
      name: "/",
      components: {
        ...layout,
        default: () => import("./pages/Home/index.vue"),
      },
    },
    {
      path: "/Authen",
      name: "Authen",
      components: {
        ...layout,
        default: () => import("./pages/Authen/index.vue"),
      },
      children: routerAuthen,
    },

    {
      path: "*",
      name: "error",
      redirect: defaultPath,

    },
  ],
});
// const DEFAULT_TITLE = "V-GAS 247";
// router.afterEach((to, from) => {
//   Vue.nextTick(() => {
//     document.title = to.meta.title || DEFAULT_TITLE;
//   });
// });
export default router;
